import React from 'react'

import { Box } from '@chakra-ui/react'
import DefaultView from './components/DefaultView'

type QuickViewerProps = {
  isOpen: boolean
  component?: React.ReactNode
}
const QuickViewer: React.FC<QuickViewerProps> = ({ isOpen, component }) => {
  return <Box w="100%">{isOpen ? component ? component : <DefaultView /> : <></>}</Box>
}

export default QuickViewer
